import script from "./RowBestellung.vue?vue&type=script&setup=true&lang=js"
export * from "./RowBestellung.vue?vue&type=script&setup=true&lang=js"

import "./RowBestellung.vue?vue&type=style&index=0&id=af7a346c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af7a346c"]])

export default __exports__